import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Avatar } from "primereact/avatar";
import { ProgressSpinner } from "primereact/progressspinner";
import { getContacts, createConversation } from "../../api/conversationApi";

const NewConversationDialog = ({ visible, onHide, onCreated }) => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const load = async () => {
      try {
        setLoading(true);
        const data = await getContacts();
        if (data?.success) setContacts(data.contacts || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [visible]);

  const handlePick = async (contact) => {
    if (creating) return;
    try {
      setCreating(true);
      const data = await createConversation([contact.id]);
      if (data?.success) {
        onCreated?.(data.conversation);
      }
    } finally {
      setCreating(false);
    }
  };

  const filtered = contacts.filter((c) => {
    if (!filter) return true;
    const f = filter.toLowerCase();
    return (
      (c.name || "").toLowerCase().includes(f) ||
      (c.email || "").toLowerCase().includes(f)
    );
  });

  return (
    <Dialog
      header="New Conversation"
      visible={visible}
      onHide={onHide}
      style={{ width: "420px" }}
      modal
    >
      <div className="new-conversation-search p-input-icon-left mb-3" style={{ width: "100%" }}>
        <i className="pi pi-search" />
        <InputText
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Search contacts…"
          style={{ width: "100%" }}
        />
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: "2rem" }}>
          <ProgressSpinner style={{ width: "40px", height: "40px" }} />
        </div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: "center", padding: "2rem", opacity: 0.6 }}>
          No contacts available
        </div>
      ) : (
        <ul className="contact-list" style={{ listStyle: "none", padding: 0, margin: 0, maxHeight: "350px", overflowY: "auto" }}>
          {filtered.map((c) => {
            const initials = (c.name || "?")
              .split(" ")
              .map((s) => s[0])
              .filter(Boolean)
              .slice(0, 2)
              .join("")
              .toUpperCase();
            return (
              <li
                key={c.id}
                onClick={() => handlePick(c)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                  padding: "0.75rem 0.5rem",
                  cursor: creating ? "wait" : "pointer",
                  borderBottom: "1px solid var(--surface-border)",
                }}
              >
                <Avatar label={initials} shape="circle" />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 500 }}>{c.name || c.email}</div>
                  <div style={{ fontSize: "0.85rem", opacity: 0.7 }}>
                    {c.role?.name} · {c.email}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </Dialog>
  );
};

export default NewConversationDialog;
